<template>
  <card :title="$t('profile.contact-list.title')">
    <template #tip>
      <el-tooltip
        :content="$t('profile.contact-list.tip')"
        placement="right"
        data-test-id="contact-list.tooltip"
      >
        <el-icon
          name="i-info-circle-small--16"
          color="fixed-light"
        />
      </el-tooltip>
    </template>
    <template #action-bar>
      <el-button
        v-if="!isCreateFormShown && !isPlaceholderShown"
        type="ghost"
        icon="i-plus-rounded--16"
        :disabled="isAddButtonDisabled || !isEditModeEnabled"
        data-test-id="contact-list.button-create"
        @click="showCreateForm"
      >
        {{ $t("action.add") }}
      </el-button>
    </template>
    <contact-create-form
      v-if="isCreateFormShown"
      @submit="hideCreateForm"
      @cancel="hideCreateForm"
    />
    <contact-list-placeholder v-if="isPlaceholderShown" />
    <contact-list
      v-if="isListShown"
      :value="addedContactList"
      :hidden-columns="hiddenColumns"
      :is-loading="isContactListFetching"
      :is-edit-disabled="isCreateFormShown"
      @is-contact-editing="handleContactEditing"
    />
    <template #footer>
      <el-button
        v-if="isPlaceholderShown && !isCreateFormShown"
        :disabled="!isEditModeEnabled"
        @click="showCreateForm"
      >
        {{ $t("action.add-contacts") }}
      </el-button>
    </template>
  </card>
</template>

<script>
import { mapGetters } from 'vuex';
import Card from '@/app/components/Card';
import ContactCreateForm from '@/app/components/profile/ContactCreateForm';
import ContactListPlaceholder from '@/app/components/profile/ContactListPlaceholder';
import ContactList from '@/app/components/profile/ContactList';

export default {
  name: 'ContactListCard',
  components: {
    Card,
    ContactCreateForm,
    ContactListPlaceholder,
    ContactList
  },
  provide() {
    return {
      isAlertShown: this.isAlertShown
    };
  },
  props: {
    hiddenColumns: {
      type: Array,
      default: () => []
    },
    isAlertShown: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isCreateFormShown: false,
      isAddButtonDisabled: false
    };
  },
  computed: {
    ...mapGetters('app', [
      'addedContactList',
      'isContactListFetching',
      'isEditModeEnabled'
    ]),
    isPlaceholderShown() {
      return this.isEmptyList && !this.isCreateFormShown;
    },
    isListShown() {
      return !this.isEmptyList;
    },
    isEmptyList() {
      return !this.isContactListFetching && this.addedContactList.length === 0;
    }
  },
  methods: {
    showCreateForm() {
      this.isCreateFormShown = true;
    },
    hideCreateForm() {
      this.isCreateFormShown = false;
    },
    handleContactEditing(editing) {
      this.isAddButtonDisabled = editing;
    }
  }
};
</script>
